module.exports = __webpack_public_path__ + "img/package_3.f624a05a.png";